import { message } from 'antd'
type NotificationType = 'success' | 'info' | 'warning' | 'error'

export const showToast = (type: NotificationType, text: string, duration?: number) => {
  const durationValue = duration ? duration : 2
  if (type === 'success') {
    message.success(text, durationValue)
  } else if (type === 'info') {
    message.info(text, durationValue)
  } else if (type === 'warning') {
    message.warning(text, durationValue)
  } else if (type === 'error') {
    message.error(text, durationValue)
  } else {
    message.success(text, durationValue)
  }
}
